export const GetPdpTemplate = (vertical: string, product_name: string, collection_name: string) => {
    const pdpDescriptionTemplates: any = {
        'FURLENCO_SALE': [
            `Buy ${product_name}. Check out latest designs for ${collection_name} under 15000. EMI Options. Free delivery.`,
            `Shop ${product_name} with Furlenco. Shop from wide range of ${collection_name} online in India at best prices. Easy EMI available.`,
            // '${product_name} with [Warranty ? months]. Deliver in 5-7 working days. Shop Furniture online now!'
        ],

        'FURLENCO_RENTAL': [
            `Rent ${product_name}. Check out latest furniture available for rent. EMI Options. Free delivery.`,
            `Rent ${product_name} with Furlenco. Rent from wide range of ${collection_name} online in India at best prices. Easy EMI available.`,
            `${product_name} with 3/6/9 months no cost EMI. Delivery with in 72 hours without delay. Rent Now!`,
            // '${product_name} with [Warranty ? months]. Deliver in 72 hours. Rent Furniture online now!',
        ],
    }
    return pdpDescriptionTemplates[vertical][Math.floor(Math.random() * pdpDescriptionTemplates[vertical].length)]
}
